// js/src/forum/index.js

import app from 'flarum/forum/app';

app.initializers.add('rebk-front-adjustments', () => {
    console.log('rebk-front-adjustments initialized');

    // Проверяем наличие расширения fof/nightmode
    if (flarum.extensions['fof-nightmode']) {
        // Навешиваем классы при переключении темы
        document.addEventListener('fofnightmodechange', (event) => {
            const body = document.body;

            if (event.detail === 'day') {
                body.classList.remove('rebk-dark');
                body.classList.add('rebk-light');
                console.log('Day mode → rebk-light');
            } else {
                body.classList.remove('rebk-light');
                body.classList.add('rebk-dark');
                console.log('Night mode → rebk-dark');
            }
        });
    }

    // При первой загрузке выставляем класс сразу
    const initialMode = localStorage.getItem('fof-nightmode');
    const body = document.body;
    if (initialMode === 'day') {
        body.classList.add('rebk-light');
    } else if (initialMode === 'night') {
        body.classList.add('rebk-dark');
    }
});
